declare const window: any;

let initialisedAppId: string;
let graphApiVersion: string;

export function fbGetSdk(appId: string, apiVersion: string) {
  graphApiVersion = apiVersion;
  let changedApp = false;
  if (initialisedAppId && appId !== initialisedAppId) {
    handleAppChange();
    changedApp = true;
  }
  initialisedAppId = appId;

  return new Promise((resolve) => {
    if (window.FB && !changedApp) {
      resolve(window.FB);
    } else {
      fbInit(appId).then(() => {
        resolve(window.FB);
      });
    }
  });
}

function fbInit(appid: string): Promise<void> {
  return new Promise((resolve: (val?: any) => void) => {
    // This function initializes the FB variable
    ((d, s, id) => {
      let js = d.getElementsByTagName(s)[0];
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      (js as any).src = '//connect.facebook.net/en_UK/sdk.js';
      if (fjs.parentNode) {
        fjs.parentNode.insertBefore(js, fjs);
      }
    })(document, 'script', 'facebook-jssdk');

    window.fbAsyncInit = () => {
      initialisedAppId = appid;
      window.FB.init({
        appId: appid,
        xfbml: true,
        version: graphApiVersion,
      });
      resolve();
    };
  });
}

export function fbLogin(scope: string): Promise<any> {
  return new Promise((resolve) => {
    window.FB.login(
      (response: any) => {
        resolve(response);
      },
      { scope },
    );
  });
}

export function fbGetLoginStatus(): Promise<any> {
  return new Promise((resolve) => {
    window.FB.getLoginStatus((response: any) => resolve(response));
  });
}

export function fbLogout(): Promise<any> {
  return new Promise<any>((resolve: (val?: any) => void) => {
    window.FB.logout((response: any) => {
      resolve(response);
    });
    resolve();
  });
}

function handleAppChange() {
  window.FB = undefined;
  const element = document.getElementById('facebook-jssdk');
  element!.remove();
}
